import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  // capitalize for one word
  function urlBuilder(query) {
    return new URLSearchParams(query).toString();
  }

  return {
    urlBuilder,
  };
}
